import { render, staticRenderFns } from "./FilterIndicador.vue?vue&type=template&id=4874422d&"
import script from "./FilterIndicador.vue?vue&type=script&lang=js&"
export * from "./FilterIndicador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports